import React from 'react';
import logo from '../../public/image/whyUs/mobile/footer/footer.webp';
import {Wrapper} from './Footer.style';
const Footer = () => {
  return (
    <Wrapper>
      <span className='footer__text'>Excellence in Manpower Management</span>
      <span className='footer__logo'>
        <img src={logo.src} alt='' />
      </span>
    </Wrapper>
  );
};

export default Footer;
